import React from "react"
import { StarText } from "components/ReviewAudit/TournamentFeedback"
import { day } from "./catalogView"

// The two tables of the Analysis tab, from the view's `tournamentFeedback` (sportya-api docs/tournament-feedback.md).

const Missing = () => <span className="text-muted">—</span>
const Mean = ({ mean }) => mean && Number.isFinite(mean.value)
  ? <>{mean.value.toFixed(1)} <span className="text-muted small">({mean.count})</span></>
  : <Missing />
// The catalog dates of a theme or reason that changed during the period.
const Dates = ({ item }) => <>
  {day(item.deactivatedAt) && <small className="d-block text-muted font-weight-normal">Deactivated on {day(item.deactivatedAt)}</small>}
  {day(item.askedSince) && <small className="d-block text-muted font-weight-normal">Asked since {day(item.askedSince)}</small>}
</>
const english = () => " stars" // the screen reader's word for the DS star of an approved „★” (the analytics stay in English)

function TableCard({ id, title, description, children, note }) {
  return <section className="card" aria-labelledby={id}><div className="card-body">
    <h3 className="font-size-16" id={id}>{title}</h3>
    <p className="text-muted">{description}</p>
    <div className="table-responsive">{children}</div>
    {note}
  </div></section>
}

// „Tournament feedback by organizer”: one row per organizer and sport, one column per theme with its mean and answers.
export function OrganizerTable({ feedback }) {
  return <TableCard id="feedback-organizers-title" title="Tournament feedback by organizer"
    description="One row per organizer and sport. Active feedback only; respondents show how reliable each mean is."
    note={<p className="text-muted small mt-2 mb-0">Each mean shows its number of answers in brackets.</p>}>
    <table className="table table-sm mb-0">
      <thead><tr>
        <th>Organizer</th><th>Sport</th><th>Tournaments</th><th>Respondents</th>
        {feedback.themes.map(theme => <th key={theme.code}>{theme.label}</th>)}
        <th>Messages</th>
      </tr></thead>
      <tbody>{feedback.organizers.map(row => <tr key={`${row.organizerId}:${row.sportType}`}>
        <th scope="row">{row.organizer || <Missing />}</th>
        <td>{row.sportType}</td><td>{row.tournaments}</td><td>{row.respondents}</td>
        {feedback.themes.map(theme => <td key={theme.code}><Mean mean={row.themes?.[theme.code]} /></td>)}
        <td>{row.messages}</td>
      </tr>)}</tbody>
    </table>
  </TableCard>
}

// „Tournament feedback reasons”: the themes in the catalog's order (Organizer first), each reason with its respondents
// in the period and the previous one, as the server orders them (the most chosen first, „Something else” last).
export function ReasonsTable({ feedback }) {
  return <TableCard id="feedback-reasons-title" title="Tournament feedback reasons"
    description={<StarText t={english} text="How many respondents chose each reason. Reasons are offered at 1–3★; Organizer reasons count only while the author’s general note is 1–3★." />}>
    <table className="table table-sm mb-0">
      <thead><tr><th>Theme</th><th>Reason</th><th>Respondents</th><th>Previous</th></tr></thead>
      <tbody>{feedback.reasons.map(theme => theme.reasons.map((reason, index) => <tr key={`${theme.themeCode}:${reason.code}`}>
        {index === 0 && <th scope="row" rowSpan={theme.reasons.length} className="align-top"><span>{theme.theme}</span><Dates item={theme} /></th>}
        <td>{reason.label}<Dates item={reason} /></td>
        <td>{reason.respondents.current}</td>
        <td className="text-muted">{reason.respondents.comparison ?? "—"}</td>
      </tr>))}</tbody>
    </table>
  </TableCard>
}
